import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { CircularProgress } from "@heroui/react";
import "./App.css";

import { UserProvider } from "providers/UserContext";
import { TripProvider } from "providers/TripContext";
import { ExchangeRatesProvider } from "providers/ExchangeRatesContext";
import { ChatProvider } from "providers/ChatContext";
import { ChatWidget } from "./components/chat";

// Lazy load all route components for better code splitting
const Checkout = lazy(() => import("./components/Checkout"));
const Trip = lazy(() => import("./pages/Trip").then(module => ({ default: module.Trip })));
const MyTrip = lazy(() => import("./pages/MyTrip").then(module => ({ default: module.MyTrip })));
const SearchTripsResults = lazy(() => import("./pages/SearchTripsResults"));
const RequestTrip = lazy(() => import("./pages/RequestTrip"));
const RequestTripSuccess = lazy(() => import("./pages/RequestTripSuccess"));
const HomePage = lazy(() => import("./pages/website/HomePage"));
const AllTripsPage = lazy(() => import("./pages/website/AllTripsPage"));
const BlogListPage = lazy(() => import("./pages/website/BlogListPage"));
const BlogPostPage = lazy(() => import("./pages/website/BlogPostPage"));
const QuienesSomosPage = lazy(() => import("./pages/website/QuienesSomosPage"));
const NotFoundPage = lazy(() => import("./pages/website/NotFoundPage"));

// Loading fallback component
const LoadingFallback = () => (
  <div className="w-screen h-screen flex justify-center items-center">
    <CircularProgress size="lg" />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <ExchangeRatesProvider>
        <TripProvider>
          <UserProvider>
            <ChatProvider>
              <Suspense fallback={<LoadingFallback />}>
                <Routes>
                  <Route path="/" element={<HomePage />}></Route>
                  <Route path="/viajes" element={<AllTripsPage />}></Route>
                  <Route path="/viajes/:tripID" element={<Trip />}></Route>
                  <Route path="/cotizar/:tripID" element={<RequestTrip />}></Route>
                  <Route path="/cotizar-exito" element={<RequestTripSuccess />}></Route>
                  <Route path="/quienes-somos" element={<QuienesSomosPage />}></Route>
                  <Route path="/blog" element={<BlogListPage />}></Route>
                  <Route path="/blog/:slug" element={<BlogPostPage />}></Route>
                  <Route path="/checkout" element={<Checkout />}></Route>
                  <Route path="/trip/:tripID" element={<Trip />}></Route>
                  <Route path="/my-trip/:tripID" element={<MyTrip />}></Route>
                  <Route path="/search-trips-results" element={<SearchTripsResults />}></Route>
                  <Route path="/request-trip/:tripID" element={<RequestTrip />}></Route>
                  <Route path="/request-trip-success" element={<RequestTripSuccess />}></Route>
                  <Route path="*" element={<NotFoundPage />}></Route>
                </Routes>
              </Suspense>
              <ChatWidget />
              <Toaster />
            </ChatProvider>
          </UserProvider>
        </TripProvider>
      </ExchangeRatesProvider>
    </BrowserRouter>
  );
}

export default App;
